<template>
    <div>
        <div class="search">
            <my-search timeScreen :order="1" :searchParams="searchParams" :selectArr="selectArr" :inputArr="inputArr" @searchEvent="searchEvent" />
            <div>
                <el-button size="small" type="primary" @click="$router.push('/keyword')">关键字管理</el-button>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addChannel">创建频道</el-button>
            </div>
        </div>
        <!-- 表格展示查询的数据  -->
        <myTable :loading="loading" :tableData="tableData" :tableHeader="tableHeader">
            <template v-slot:table_after>
                <el-table-column label="频道图标" align="center" prop="img" width="120">
                    <template slot-scope="{ row }">
                        <el-image class="logo" :src="row.img | formatImg " alt="">
						</el-image>
                    </template></el-table-column>
                <el-table-column label="所属关键字" align="center" prop="keywordsList">
                    <template slot-scope="{ row }">
                        <el-tooltip class="item" effect="dark" placement="right" v-if="row.keywordsList[1]">
                            <div slot="content" class="tooltip-content">
                                <p v-for="(item, index) in row.keywordsList" :key="index">
                                    {{ item.keywordsName }}
                                </p>
                            </div>
                            <span>
                                {{ row.keywordsList[0].keywordsName + "..." }}
                            </span>
                        </el-tooltip>
                        <span v-else>
                            {{  row.keywordsList[0]?row.keywordsList[0].keywordsName:'--' }}</span>
                    </template></el-table-column>
                <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.status == 2" class="item" effect="dark" placement="right">
                            <div slot="content">
                                {{ scope.row.examineDescribe }}
                            </div>
                            <span>
                                {{ scope.row.status | formatStatus }}
                            </span>
                        </el-tooltip>
                        <span v-else>
                            {{ scope.row.status | formatStatus }}</span>
                    </template></el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime" width="180"></el-table-column>
                <el-table-column label="操作" min-width="150px" align="center">
                    <template slot-scope="{ row }">
                        <el-button v-if="
                                ['0', '2'].includes(row.status) &&
                                isShow('channelAudit')
                            " type="text" size="mini" @click="operateChannel(row)">审核</el-button>
                        <el-button v-if="row.status == '3' && isShow('channelOpen')" type="text" size="mini" @click="operateChannel(row)">开启</el-button>
                        <el-button v-if="row.status == '1' && isShow('channelClose')" type="text" size="mini" @click="operateChannel(row)">关闭</el-button>

                        <el-button v-if="
                                isShow('channelEdit') &&
                                row.insertUser == userId
                            " type="text" size="mini" @click="edit(row)">编辑</el-button>
                        <el-button v-if='row.overallType==1' type="text" size="mini" @click="edit(row)">编辑</el-button>
                        <el-button v-if='row.overallType==1' type="text" size="mini" @click="addActile(row)" :disabled=" ['0', '2'].includes(row.status)">添加文章</el-button>
                    </template>
                </el-table-column>
            </template>
        </myTable>
        <!-- 分页器 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <!-- 添加、修改组件 -->
        <my-dialog v-if="isDialogShow" :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :rules="rules" @submitForm="submitForm">
            <!-- 上传图片和关键字选择 -->
            <template v-slot:upload>
                <el-form-item label="频道名称" prop="name">
                    <el-input placeholder="请输入频道名称" v-model="operForm.name">
                    </el-input>
                </el-form-item>
                <el-form-item label="频道类型" prop="type">
                    <el-select v-model="operForm.type" value-key="value" placeholder="请选择关键字" @change="channecChange" clearable>
                        <el-option v-for="item in channelTypeList" :key="item.name" :label="item.name" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收费类型" prop="payModel">
                    <el-select v-model="operForm.payModel" placeholder="请选择收费类型" clearable>
                        <el-option-group v-for="item in payTypeList" :key="item.name" :label="item.name" :value="item.value" clearable>
                            <el-option v-for="item1 in item.dictList" :key="item1.name" :label="item1.name" :value="item1.value">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <el-form-item label="关键字" prop="keywordsList">
                    <el-select v-model="operForm.keywordsList" multiple value-key="keywordsName" placeholder="请选择关键字" clearable>
                        <el-option v-for="item in keywords" :key="item.keywordsName" :label="item.keywordsName" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="频道描述">
                    <el-input type="textarea" placeholder="请输入频道描述"  v-model="operForm.description" maxlength="200" show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="频道图标">
                    <upload :operForm="operForm"></upload>
                </el-form-item>
            </template>
        </my-dialog>

        <!-- 审核对话框 -->
        <auditForm v-if="auditFormVisible" :auditFormVisible.sync="auditFormVisible" @submitForm="submitAuditForm"></auditForm>
        <!-- 添加文章 -->
        <addActile v-if="addActVisible" :addActVisible.sync="addActVisible" :channelId='channelId' :unitId='unitId' :payModel="payModel"></addActile>
    </div>
</template>

<script>
import {
    keywordsList,
    unitList,
    delChannel,
    updateChannel,
    addChannel,
    channelList,
    operateChannel,
    queryType,
} from "@/network/content/channel.js";
import mixins from "@/mixins/common";
import auditForm from "./auditForm.vue";
import addActile from "./addActile.vue";
import upload from "./upload.vue";
import { mapState } from "vuex";
import {  baseImg } from "@/common/global.js";
export default {
    name: "channel",
    mixins: [mixins],
    components: { auditForm, upload, addActile },
    data() {
        return {
            auditFormVisible: false,
            addActVisible: false,
            tableHeader: Object.freeze([
                {
                    name: "频道名称",
                    prop: "name",
                },
                {
                    name: "频道类型",
                    prop: "type",
                    formatData(val) {
                        return ["基础频道", "隐藏频道"][Number(val) - 1]; //  1和2
                    },
                },
                {
                    name: "频道分类",
                    prop: "overallType",
                    formatData(val) {
                        return ["企业频道", "全局频道"][Number(val)]; //  0和1
                    },
                },
                {
                    name: "收费模式",
                    prop: "payModel",
                    formatData(val) {
                        return ["公开模式", "会员", "隐藏模式"][
                            Number(val) - 1
                        ];
                    },
                },
                {
                    name: "归属公司",
                    prop: "unitName",
                },
                {
                    name: "频道描述",
                    prop: "description",
                },
            ]),
            selectArr: [
                {
                    defaultText: "请选择频道状态", //0审核，1正常，2失败，3关闭
                    name: "status",
                    getData: "value",
                    defaultOptions: [
                        { label: "审核", value: 0 },
                        { label: "正常", value: 1 },
                        { label: "失败", value: 2 },
                        { label: "关闭", value: 3 },
                    ],
                },
                {
                    defaultText: "请选择频道类型",
                    name: "overallType",
                    // getData: "value",
                    defaultOptions: [
                        { label: "企业频道", value: 0 },
                        { label: "全局频道", value: 1 },

                    ],
                },
            ],
            inputArr: [
                {
                    name: "name",
                    defaultText: "请输入名称",
                },
                {
                    name: "unitName",
                    defaultText: "请输入归属公司",
                },
            ],
            searchParams: {
                name: "",
                status: "",
                unitName: "",
                timeOptions: [],
            },
            selectArrAdd: [
                // {
                //     optionLabel: "shortName",
                //     prop: "unitId",
                //     label: "归属企业",
                //     getData: "id",
                //     defaultOptions: [],
                // },
                // {
                //     name: "name",
                //     value: "type",
                //     label: "频道类型",
                //     getData: "value",
                //     getCurrent(val) {
                //         console.log(val);
                //     },
                //     defaultOptions: [
                //         // { label: "公开频道", id: "0" },
                //         // { label: "收费频道", id: "1" },
                //         // { label: "隐藏频道", id: "2" },
                //     ],
                // },
                // {
                //     name: "name",
                //     value: "payModel",
                //     label: "收费模式",
                //     getData: "value",
                //     defaultOptions: [
                //         { label: "公开", id: "0" },
                //         { label: "会员收费", id: "1" },
                //         { label: "会员折扣", id: "2" },
                //     ],
                // },
            ],
            channelTypeList: [],
            payTypeList: [],
            //添加、编辑双向绑定值
            operForm: {
                name: "", //频道名称
                type: "", //频道类型
                payModel: "", //收费模式
                unitId: "", // 归属公司Id
                hot: "", //热度
                description: "", //频道描述
                keywordsList: [],
            },
            // 弹出框的表单验证
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入频道名称",
                        trigger: "blur",
                    },
                ],
                payModel: [
                    {
                        required: true,
                        message: "请输入收费模式",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请输入频道类型",
                        trigger: "blur",
                    },
                ],
                unitId: [
                    {
                        required: true,
                        message: "请输入归属企业",
                        trigger: "blur",
                    },
                ],
                keywordsList: [
                    {
                        required: true,
                        message: "请输入关键字",
                        trigger: "blur",
                    },
                ],
                img: [
                    {
                        required: true,
                        message: "请上传频道图片",
                    },
                ],
            },
            keywords: [],
            unitList: [],
            channelId: "",
            unitId: ""
        };
    },
    computed: {
        ...mapState(["buttons", "userId"]),
    },
    filters: {
        formatStatus(status) {
            let statusArray = ["待审核", "审核通过", "审核失败", "关闭"];
            return statusArray[status];
        },
        formatImg(src) {
            return `${baseImg}${src}`;
        },
    },
    methods: {
        isShow(btn) {
            return this.buttons.indexOf(btn) !== -1;
        },
        getInitData(currentPage = this.pageParams.currentPage) {
            let { timeOptions, name, status, unitName, overallType } = this.searchParams;
            let params = {
                data: {
                    name,
                    status,
                    unitName,
                    overallType
                },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: currentPage,
                size: this.pageParams.pageSize,
            };
            channelList(params).then((e) => {
                this.loading = true;
                let { code, data } = e.data;
                if (code == 200) {
                    this.loading = false;
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                    // this.pageParams.currentPage = currentPage;
                }
            });
        },
        getkeywords() {
            keywordsList().then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    this.keywords = data;
                }
            });
        },
        getUnitList() {
            unitList().then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    this.selectArrAdd[0].defaultOptions = data;
                }
            });
        },
        queryChannelType() {
            queryType().then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    // this.selectArrAdd[1].defaultOptions = data;
                    data[0].dictList[0].dictList.push({
                        name: "公开模式",
                        value: 1,
                    });
                    data[1].dictList[0].dictList.push({
                        name: "隐藏模式",
                        value: 3,
                    });
                    this.channelTypeList = data;
                }
            });
        },
        channecChange(val) {
            this.payTypeList = val.dictList;
            if (this.operForm.payModel) {
                this.operForm.payModel = "";
            }
        },
        // 搜索
        searchEvent() {
            this.getInitData(1);
        },
        //  添加频道
        addChannel() {
            // 清空
            this.operForm = {};
            this.operTitle = true;
            this.isDialogShow = true;
        },
        //提交表单
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let params = {
                    ...this.operForm,
                    type: this.operForm.type.value,
                    overallType: 1

                };
                let api = operTitle ? addChannel : updateChannel;
                let { data } = await api(params);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        // 删除
        deleteitem(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await delChannel({ id: row.id });
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
        // 操作
        operateChannel(row) {
            //审核
            if (row.status == 0 || row.status == 2) {
                this.auditFormVisible = true;
                this.id = row.id;
                return;
            }
            const params = {
                id: row.id,
                status: row.status == 3 ? 1 : 3,
            };
            // 开启
            if (row.status == 1) {
                this.$confirm("关闭当前频道, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.operate(params);
                    })
                    .catch(() => { });
                return;
            }
            // 关闭
            if (row.status == 3) {
                this.operate(params);
                return;
            }
        },
        submitAuditForm(val) {
            const params = {
                id: this.id,
                status: val.status,
                examineDescribe: val.examineDescribe,
            };
            this.operate(params);
        },
        operate(params) {
            operateChannel(params)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success("操作成功");
                        this.auditFormVisible = false;
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
        // 全局频道编辑
        edit(row) {
            this.payTypeList =
                this.channelTypeList[Number(row.type) - 1].dictList;
            this.operForm = { ...row };
            this.operForm.type = { value: Number(row.type) };
            this.operForm.payModel = Number(this.operForm.payModel);
            // this.operForm.payModel = Number(this.operForm.payModel);
            // this.keywords = row.keywordsList
            this.operTitle = false;
            this.isDialogShow = true;
        },
        // 全局频道添加文章
        addActile(row) {
            this.addActVisible = true
            this.channelId = row.id
            this.unitId = row.unitId
			 this.payModel = row.payModel
        },
    },
    created() {
        this.getkeywords();
        // this.getUnitList();
        this.queryChannelType();
        this.pageParams.pageSize = 10
    },
};
</script>

<style lang="scss" scoped>
.search {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.addBtn {
    margin: 0 0 10px 20px;
}
.el-select {
    width: 100%;
}

// .content {
//     max-height: 150px;
//     width: 150px;
//     overflow: auto;
//     .title {
//         padding: 5px 0;
//     }
//     p {
//         padding: 3px 0;
//     }
// }

::v-deep .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.logo {
	/deep/ img{
		width: 40px;
		height: 40px;
	}
}
</style>